import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Spin } from 'antd';
import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import PagesList from './pages/Pages/PageList';
import PageDetails from './pages/Pages/PageDetails';
import CreatePost from './pages/Posts/CreatePost';
import PostList from './pages/Posts/PostList';
import AutoPostList from './pages/AutoPost/AutoPostList';
import AdAccounts from './pages/Ads/AdAccounts';
import AdList from './pages/Ads/AdList';
import AdReports from './pages/Ads/AdReports';
import Profile from './pages/Settings/Profile';
import UserManagement from './pages/Admin/UserManagement';
import ProductList from './pages/Products/ProductList';
import ProductDetail from './pages/Products/ProductDetail';
import { UserRole } from './types';
import './App.css';

// Protected Route Component
const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Spin size="large" /></div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

const AdminRoute = () => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Spin size="large" /></div>;
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  
  return user?.role === UserRole.ADMIN ? <Outlet /> : <Navigate to="/" replace />;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          
          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/pages" element={<PagesList />} />
              <Route path="/pages/:id" element={<PageDetails />} />
              <Route path="/posts/create" element={<CreatePost />} />
              <Route path="/posts/list" element={<PostList />} />
              <Route path="/auto-post" element={<AutoPostList />} />
              <Route path="/ads/accounts" element={<AdAccounts />} />
              <Route path="/ads/list" element={<AdList />} />
              <Route path="/ads/reports" element={<AdReports />} />
              <Route path="/settings/profile" element={<Profile />} />

              {/* Product Routes */}
              <Route path="/products/list" element={<ProductList />} />
              <Route path="/products/create" element={<ProductDetail />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              
              {/* Admin Routes */}
              <Route element={<AdminRoute />}>
                <Route path="/admin/users" element={<UserManagement />} />
              </Route>
            </Route>
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;

